import React, { useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Tabs } from 'antd'
import { useHistory, useParams} from 'react-router-dom'
function FAQSContent() {
    const { TabPane } = Tabs;
    const history = useHistory();
    const { faq } = useParams();
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    window.addEventListener('resize', handleResize)
    function handleResize() {
        setScreenWidth(window.innerWidth);
    }
    console.log(screenWidth)
    return (
        <div className="FAQSContent layoutTabs">
            <div className="container">
                <div className="title">
                    <h5 className="title">FAQS</h5>
                    <div className="formInput">
                        <Input placeholder="Tìm kiếm" prefix={<FontAwesomeIcon icon="search" />} />
                    </div>
                </div>
                <div className="FAQSTabs tabStyleSuport">
                    <Tabs tabPosition={screenWidth >= 768 ? "left" : "top"}
                        activeKey={faq} defaultActiveKey="lien-he"
                        onChange={(key) => {
                            history.push(`/faqs/${key}`);
                        }}>
                        <TabPane tab="Di chuyển" key="di-chuyen">
                            <div className="contentTap">
                                <div className="titleTabs">
                                    Khách sạn có bãi đỗ xe không? Chi phí bao nhiêu? Có gồm trong tiền phòng?
                                </div>
                                <p>
                                    JO ơi, SOJO HOTELS có bãi gửi xe miễn phí dành cho khách hàng. Vui lòng gửi xe theo chỉ dẫn hoặc liên hệ GURU để được hỗ trợ.
                                </p>
                                <div className="titleTabs">
                                    Tôi có thể thuê xe máy hoặc ô tô tại đâu?
                                </div>
                                <p>
                                    JO ơi, hiện SOJO HOTELS chưa cung cấp dịch vụ thuê xe máy/ô tô. Tuy nhiên hãy để GURU giúp bạn đặt phương tiện mình mong muốn nhé.
                                </p>
                                <div className="titleTabs">
                                    Khách sạn có cung cấp dịch vụ đưa/đón sân bay không?
                                </div>
                                <p>
                                    JO ơi, hiện SOJO HOTELS chưa cung cấp dịch vụ đưa/đón sân bay. Tuy nhiên hãy để GURU giúp bạn đặt chuyến xe tới địa điểm bạn mong muốn nhé.
                                </p>
                                <div className="titleTabs">
                                    Làm thế nào tôi có thể đến khách sạn?
                                </div>
                                <p>
                                    JO ơi, vui lòng liên hệ GURU theo số 19001188 để được hỗ trợ.
                                </p>
                            </div>
                        </TabPane>
                        <TabPane tab="Dịch vụ khách sạn" key="dich-vu-khach-san">
                            <div className="titleTabs">
                                Khách sạn có cho phép hút thuốc không?
                            </div>
                            <p>
                                JO ơi, SOJO HOTELS là khách sạn không khói thuốc bao gồm cả thuốc lá điện tử. Vui lòng không hút thuốc khi nghỉ tại SOJO HOTELS.
                            </p>
                            <div className="titleTabs">
                                Có được đưa vật nuôi vào khách sạn không?
                            </div>
                            <p>
                                JO ơi, để đảm bảo sự thoải mái cho tất cả khách hàng, SOJO HOTELS không tiếp đón vật nuôi tại khách sạn.
                            </p>
                            <div className="titleTabs">
                                Khách sạn có dịch vụ thăm quan trong ngày hoặc nửa ngày không?
                            </div>
                            <p>
                                JO ơi, hãy để SOJO HOTELS là người hướng dẫn tận tâm giúp bạn tham quan những điểm đến nổi tiếng trong thành phố. Vui lòng liên hệ GURU để được hỗ trợ đặt dịch vụ.
                            </p>
                            <div className="titleTabs">
                                Khu vực GYM có được sử dụng miễn phí không?
                            </div>
                            <p>
                                JO ơi, đừng bỏ quên thói quen luyện tập ngay cả khi đang di chuyển với phòng tập GYM mở cửa 24/7 và hoàn toàn miễn phí tại SOJO HOTELS.
                            </p>
                            <div className="titleTabs">
                                Làm thế nào để sử dụng máy bán hàng tự động?
                            </div>
                            <p>
                                JO ơi, máy bán hàng tự động được trang bị tại khu vực JO 247 với đầy đủ các vật dụng thiết yếu cho chuyến đi của bạn. Bạn có thể sử dụng tiền mặt hoặc liên hệ GURU để được trợ giúp.
                            </p>
                            <div className="titleTabs">
                                Khách sạn có bữa sáng phục vụ tại phòng không?
                            </div>
                            <p>
                                JO ơi, SOJO HOTELS không phục vụ bữa sáng tại phòng. Bạn có thể đặt trước bữa sáng khi đặt phòng hoặc liên hệ GURU theo số 19001188 để được hỗ trợ.
                            </p>
                            <div className="titleTabs">
                                Giá phòng đã bao gồm ăn sáng chưa?
                            </div>
                            <p>
                                JO ơi, giá phòng tại SOJO HOTELS chưa bao gồm bữa sáng. Bạn có thể đặt thêm bữa sáng đặc biệt với thực đơn thay đổi theo ngày kèm trà/cafe trong quá trình đặt phòng hoặc liên hệ GURU bất cứ lúc nào theo số 19001188 để được hỗ trợ.
                            </p>
                        </TabPane>
                        <TabPane tab="Mandala" key="mandala">
                            <div className="titleTabs">
                                Tôi có thể đặt phòng họp tại khách sạn không?
                            </div>
                            <p>
                                JO ơi, bạn có thể đặt phòng họp tại JO 247. Vui lòng liên hệ GURU để được hỗ trợ.
                            </p>
                            <div className="titleTabs">
                                Thời gian mở cửa của bar là như nào?
                            </div>
                            <p>
                                JO ơi, bạn luôn được chào đón tại JO 247 vào bất cứ thời điểm nào trong ngày. Đừng bỏ lỡ những trải nghiệm bất ngờ và thú vị tại JO 247 nhé.
                            </p>
                        </TabPane>
                        <TabPane tab="Liên hệ" key="lien-he">
                            <div className="titleTabs">
                                Tôi muốn ứng tuyển vị trí GURU tại khách sạn, tôi phải liên hệ với ai?
                            </div>
                            <p>
                                JO ơi, cảm ơn bạn đã quan tâm đến SOJO HOTELS.

                                Để biết thông tin chi tiết về các vị trí đang tuyển dụng, vui lòng truy cập website: http://sojo.mtalent.com.vn/
                            </p>
                            <div className="titleTabs">
                                Tôi muốn hợp tác kinh doanh với khách sạn, tôi phải liên hệ với ai?
                            </div>
                            <p>
                                JO ơi, cảm ơn bạn đã quan tâm đến SOJO HOTELS. Vui lòng liên hệ bộ phận Kinh Doanh của chúng tôi theo email sojo@sojohotels.com hoặc SĐT: 19001188 để trao đổi cụ thể.
                            </p>
                            <div className="titleTabs">
                                Tôi muốn liên hệ với bộ phận chăm sóc khách hàng?
                            </div>
                            <p>
                                JO ơi, vui lòng liên hệ bộ phận CSKH của chúng tôi theo email sojo@sojohotels.com hoặc SĐT: 19001188
                            </p>

                        </TabPane>
                        <TabPane tab="Nhân và trả phòng" key="nhan-va-tra-phong">
                            <div className="titleTabs">
                                Có những cách nào để mở khóa phòng?
                            </div>
                            <p>
                                JO ơi, thật dễ dàng để mở cửa phòng nghỉ tại SOJO HOTELS với hai cách sau:

                                - Mở phòng bằng Khóa điện tử: với trường hợp làm thủ tục nhận phòng trực tuyến, bạn cần kích hoạt khóa tại Kiosk và mở khóa phòng bằng App SOJO HOTELS.

                                - Mở phòng bằng Khóa thẻ từ: với trường hợp làm thủ tục nhận phòng tại Kiosk của khách sạn, bạn sẽ nhận được khóa thẻ từ. Đừng quên trả lại khóa thẻ từ tại hộp khóa cạnh quầy Kiosk khi trả phòng.
                            </p>
                            <div className="titleTabs">
                                Thời gian nhận phòng và trả phòng là mấy giờ?
                            </div>
                            <p>
                                JO ơi, thời gian nhận phòng (check-in) tại SOJO HOTELS là sau 14h, và trả phòng (check-out) trước 12h.
                            </p>
                            <div className="titleTabs">
                                Quy trình trả phòng tại khách sạn như nào?
                            </div>
                            <p>
                                JO ơi, bạn có thể trả phòng trực tuyến qua App SOJO HOTELS, qua Tablet trong phòng, hoặc trả phòng tại quầy Kiosk của khách sạn
                            </p>
                            <div className="titleTabs">
                                Quy trình check-in và nhận phòng tại SOJO HOTELS như nào?
                            </div>
                            <p>
                                JO ơi, bạn có thể nhận phòng và nhận khóa điện tử trực tuyến khi sử dụng App SOJO HOTELS hoặc nhận phòng và thêm khóa thẻ từ tại kiosk khách sạn.

                                Thời gian nhận phòng tại khách sạn là sau 14h.
                            </p>
                        </TabPane>
                        <TabPane tab="Thanh toán" key="thanh-toan">
                            <div className="titleTabs">
                                Tôi phải thanh toán những chi phí phát sinh khi nghỉ tại khách sạn như nào?
                            </div>
                            <p>
                                JO ơi, bạn có thể thanh toán chi phí phát sinh từ những thiệt hại, hỏng hóc không may xảy ra tại SOJO HOTELS khi làm thủ tục trả phòng tại quầy Kiosk của chúng tôi hoặc liên hệ trực tiếp với GURU để được hỗ trợ.
                            </p>
                            <div className="titleTabs">
                                Tôi có câu thắc mắc về hóa đơn, tôi có thể liên lạc với ai?
                            </div>
                            <p>
                                JO ơi, vui lòng liên hệ với GURU theo số 19001188 để được giải đáp mọi thắc mắc. GURU luôn sẵn sàng hỗ trợ bạn.
                            </p>
                            <div className="titleTabs">
                                Khách sạn chấp nhận những hình thức thanh toán nào
                            </div>
                            <p>
                                JO ơi, chúng tôi chấp nhận thanh toán tiền mặt, thanh toán trực tuyến các loại thẻ quốc tế (Visa, Master, JCB…), thẻ thanh toán nội địa và chuyển khoản ngân hàng.
                            </p>
                        </TabPane>
                        <TabPane tab="Đặt phòng" key="dat-phong">
                            <div className="titleTabs">
                                Tôi có thể thay đổi đặt phòng của mình ở đâu?
                            </div>
                            <p>
                                JO ơi, bạn có thể truy cập mục Đặt phòng của tôi trên website hoặc App SOJO HOTELS để thay đổi đặt phòng của mình.
                            </p>
                            <div className="titleTabs">
                                Nếu tôi hủy đặt phòng, tôi có phải trả phí không?
                            </div>
                            <p>
                                JO ơi, phí hủy phòng có thể được áp dụng tùy từng trường hợp:

                                a. Đối với đặt phòng dưới 8 phòng/khách lẻ

                                Thời gian thông báo và Phí hủy phòng

                                Hủy không phí: 2 ngày trước ngày nhận phòng

                                Hủy nửa phí: 1 ngày trước ngày nhận phòng

                                Hủy tính phí: Trong cùng ngày nhận phòng

                                b. Đối với đặt phòng từ 8 phòng trở lên/khách đoàn

                                Thời gian thông báo và Phí hủy phòng

                                Hủy không phí: 7 ngày trước ngày nhận phòng

                                Hủy nửa phí: 5 ngày trước ngày nhận phòng

                                Hủy tính phí: 2 ngày trước ngày nhận phòng


                            </p>
                            <div className="titleTabs">
                                Tôi có thể chọn phòng theo ý muốn không?
                            </div>
                            <p>
                                JO ơi, bạn có thể chọn phòng theo ý muốn (tùy thuộc vào tình trạng phòng còn trống) khi làm thủ tục nhận phòng trên Website, trên Mobile App SOJO HOTELS hoặc check in tại quầy Kiosk của khách sạn. Vui lòng liên hệ Hotline: 19001188 để được hướng dẫn chi tiết!
                            </p>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        </div>
    )
}
export default FAQSContent;